import {Component, EventEmitter, Output} from '@angular/core';
import {StateService} from "@uirouter/angular";
import {kanUsersService} from "../../../services/services/users";

@Component({
  selector: 'kan-header',
  templateUrl: './component.html',
  styleUrls: ['./component.scss']
})
export class kanHeader {
  @Output() private navToggle = new EventEmitter<boolean>();

  constructor(private userService: kanUsersService,
              private stateService: StateService) {

  }

  public navOpen(event: any): void {
    this.navToggle.emit(true);
  }

  public isAuthenticated(): boolean {
    return this.userService.isAuthenticated();
  }

  public logout(event: any): void {
    this.userService.logout();
    this.stateService.go('app.login');
  }

  public goHome(): void {
      this.stateService.go('app.home');
  }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/header/component.ts